import React from 'react'

export const visibleEyeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.04688 6.24859C0.984374 6.08821 0.984374 5.91179 1.04688 5.75141C1.65562 4.34546 2.68893 3.14335 4.0158 2.29746C5.34268 1.45157 6.90336 1 8.5 1C10.0966 1 11.6573 1.45157 12.9842 2.29746C14.3111 3.14335 15.3444 4.34546 15.9531 5.75141C16.0156 5.91179 16.0156 6.08821 15.9531 6.24859C15.3444 7.65454 14.3111 8.85665 12.9842 9.70254C11.6573 10.5484 10.0966 11 8.5 11C6.90336 11 5.34268 10.5484 4.0158 9.70254C2.68893 8.85665 1.65562 7.65454 1.04688 6.24859Z"
      stroke="#555555"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 8.14305C9.74258 8.14305 10.7499 7.18357 10.7499 6C10.7499 4.81643 9.74258 3.85695 8.5 3.85695C7.25742 3.85695 6.25011 4.81643 6.25011 6C6.25011 7.18357 7.25742 8.14305 8.5 8.14305Z"
      stroke="#555555"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
